import { errorToast, toast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useInvitationResendMutation } from "@/v2-backoffice-client/invitation/resend/invitation.resend.mutation"
import { INVITATION_RESENT_TITLE } from "@/v2-backoffice-client/invitation/resend/invitation.resend.constants"

export type InvitationResendButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  invitationId: number
  onCompleted?(): void
}

function InvitationResendButton(props: InvitationResendButtonProps) {
  const { invitationId, confirmContent, onCompleted, ...confirmButtonProps } =
    props

  const [resendInvitation, { loading, error }] = useInvitationResendMutation({
    onCompleted(data) {
      toast({
        variant: "success",
        title: INVITATION_RESENT_TITLE,
        description: data.resendUserInvitation?.Email ?? undefined,
      })
      onCompleted?.()
    },
  })

  errorToast(error, {
    title: "Failed to resend invitation",
  })

  return (
    <ConfirmButton
      id="invitation-resend-button"
      size="tiny"
      iconSrc="paper-plane"
      content="Resend invitation"
      variant="ghost"
      confirmVariant="warning"
      confirmContent={
        confirmContent ?? "Are you sure you want to resend this invitation?"
      }
      isLoading={loading}
      onConfirm={() => {
        resendInvitation({ variables: { id: invitationId } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default InvitationResendButton
